import { Button, InputGroup } from '@blueprintjs/core';
import { Dispatch, SetStateAction } from 'react';
import styles from './InsuranceCardSection.module.css';
import { customer, insurance } from '@axo/shared/data-access/types';
import { UseMutationResult, UseQueryResult } from 'react-query';

export function CustomerEmailInput({
  updateEmail,
  setUpdateEmail,
  customer,
  insurance,
  disabled,
  updateCustomer,
}: {
  updateEmail: string | null;
  setUpdateEmail: Dispatch<SetStateAction<string | null>>;
  customer: UseQueryResult<customer.Customer>;
  insurance: insurance.Insurance;
  disabled?: boolean;
  updateCustomer: UseMutationResult<
    customer.Customer,
    unknown,
    customer.UpdateCustomerParams,
    unknown
  >;
}) {
  return (
    <InputGroup
      id="insuranceEmail"
      leftIcon="envelope"
      value={updateEmail ?? customer.data?.Email ?? ''}
      onChange={(e) => setUpdateEmail(e.target.value)}
      readOnly={insurance.Status !== 'active' || !updateEmail}
      inputClassName={styles.rowInput}
      disabled={disabled}
      className={styles.rowInputGroup}
      rightElement={
        updateEmail !== null ? (
          <>
            <Button
              minimal
              text="Save"
              icon="floppy-disk"
              disabled={disabled || updateEmail === customer.data?.Email}
              loading={updateCustomer.isLoading}
              onClick={async () => {
                if (!customer.data || !updateEmail) return;

                await updateCustomer.mutateAsync({
                  customerID: customer.data.ID,
                  customerEdits: {
                    ...customer.data,
                    Email: updateEmail,
                  },
                });

                setUpdateEmail(null);
              }}
            />
            <Button
              minimal
              text="Cancel"
              icon="cross"
              disabled={updateCustomer.isLoading}
              onClick={() => setUpdateEmail(null)}
            />
          </>
        ) : insurance.Status === 'active' ? (
          <Button
            minimal
            text="Edit"
            icon="edit"
            disabled={disabled}
            onClick={() => setUpdateEmail(customer.data?.Email ?? '')}
          />
        ) : undefined
      }
    />
  );
}
